import { DefaultLayout } from '@fondationcss/ui';

export const getCustomRoutes = () => [  
    {
      path: '/',
      component: DefaultLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'default-view',
          path: '',
          component: () => import('@/views/default-view.vue')
        },
        {
          name: 'docs',
          path: '/docs/:pathMatch(.*)',
          component: () => import('@/views/documentation.vue'),
          meta: { title: 'Documentation' }
        },
      ]
    },
    {
      path: '/parcours/',
      component: DefaultLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'parcours-eleve',
          path: 'eleve',
          component: () => import('@/views/parcours/eleve.vue'),
          meta: { title: 'Parcours élève' }
        },
        {
          name: 'parcours-enseignant',
          path: 'enseignant',
          component: () => import('@/views/parcours/enseignant.vue'),
          meta: { title: 'Parcours enseignant' }
        },
        {
          name: 'parcours-planification',
          path: 'planification',
          component: () => import('@/views/parcours/planification.vue'),
          meta: { title: 'Planification' }
        },
        {
          name: 'parcours-gestion',
          path: 'gestion',
          component: () => import('@/views/parcours/gestion.vue'),
          meta: { title: 'Gestion' }
        }
      ]
    },
    {
      path: '/lignedetemps/',
      component: DefaultLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'timeline-select',
          path: 'visualisateur',
          component: () => import('@/views/timeline/select.vue')
        },
        {
          name: 'timeline-select-with-user',
          path: 'visualisateur/:userId',
          component: () => import('@/views/timeline/select.vue')
        },
        {
          name: 'timeline-view',
          path: 'visualisateur/:userId/:timelineId',
          component: () => import('@/views/timeline/view.vue')
        },
        {
          name: 'timeline-settings2',
          path: 'parametres2',
          component: () => import('@/views/timeline/settings2.vue')
        }
      ]
    },
    {
      path: '/admin/',
      component: DefaultLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'import-export',
          path: 'import-export',
          component: () => import('@/views/import-export.vue')
        },
        {
          name: 'admin-systeme-inscription',
          path: 'systeme/inscription',
          component: () => import('@/views/admin/systeme/inscription.vue'),
          meta: { title: 'Inscription' }
        }
      ]
    }
];